import { Component, OnInit } from '@angular/core';
import { BannerAppComponent } from '../../../components/banner-app/banner-app.component';
import { FooterAppComponent } from '../../../components/footer-app/footer-app.component';
import { getFromStorage } from '../../../helpers/storageUtils';

@Component({
  selector: 'app-retoma-duplicado',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent],
  templateUrl: './retoma-duplicado.component.html',
  styleUrl: './retoma-duplicado.component.scss',
})
export class RetomaDuplicadoComponent implements OnInit {
  urlRetoma = '';
  // private storageService = inject(StorageService);

  ngOnInit(): void {
    this.getRetakeUrl();
  }

  handleClick(): void {
    if (this.urlRetoma !== '') {
      window.location.href = this.urlRetoma;
    }
  }

  getRetakeUrl(): string {
    const retakeUrl: string | null = getFromStorage('UrlRetoma', 'session');

    this.urlRetoma = retakeUrl ? retakeUrl : '';
    return this.urlRetoma;
  }
}
